"use client";

import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import Link from "next/link";

import "./BlogDetails.css";
// import BlogNewsbox from "../BlogNewsbox/BlogNewsbox";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Scrollbar } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import ShareButton from "../ShareButton/ShareButton";
import Image from "next/image";

function BlogDetails({ blogData, LatestBlogData, slug }) {
  const [isMobilescreen, setMobileScreen] = useState(false);
  useEffect(() => {
    if (window.innerWidth < 767) {
      setMobileScreen(true);
    }
  }, []);
  const activelink = slug;
  console.log(blogData);
  return (
    <>
      <div
        id="reecosys-contact-wrapper "
        className="relative section-padding inner-flex inner-flex-medium"
      >
        <section
          className="reecosys-section section-padding relative "
          id="reecosys-contact-section-banner"
        >
          <div className="commonpage_banner main-container inner-flex inner-flex-medium">
            <div className="flex-row j-c-sb w100 ">
              <div className="inner-flex" style={{ maxWidth: "60rem" }}>
                {blogData?.title && (
                  <div className="">
                    <div className="banner-title blog-title">
                      <h1 className="capitalize bold-fonts" style={{ textTransform: 'capitalize'}}>
                        {blogData?.title}
                      </h1>
                    </div>
                  </div>
                )}
                {blogData.published_date && (
                  <div className="flex-row j-c-sb w100 ">
                    <div className="published_blog_date section-content">
                      <p>{blogData.published_date}</p>
                    </div>
                    <div className="visible-tab-mobile">
                      <ShareButton
                        title={blogData.title}
                        text={blogData.title}
                        url={`https://www.nbbuildcon.com/blogs/${blogData.slug}`}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="hide-tab-mobile">
                <ShareButton
                  title={blogData.title}
                  text={blogData.title}
                  url={`https://www.nbbuildcon.com/blogs/${blogData.slug}`}
                />
              </div>
            </div>

            <div className="relative" style={{ aspectRatio: "16 / 9" }}>
              {blogData?.image_full && (
                <Image
                  src={`${blogData?.image_full}&w=1560&q=100`}
                  fill
                  alt="blogs"
                />
              )}
            </div>
          </div>
          {/* <div className="black_overlay"></div> */}
        </section>
        <section
          className="reecosys-section relative"
          id="reecosys-blog-detail-section-2"
        >
          <div className="main-container">
            <div className="inner-flex">
              <div className="blog-grid">
                <div className="blog-grid-one">
                  <div className="inner-flex inner-flex-medium">
                    {blogData.description && (
                      <div className="blog_bind_data">
                        <div
                          dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(blogData.description),
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default BlogDetails;
